import React, { memo } from 'react'

import { Button, Icon, Search, Upload2 } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import EmptyStateIllustration from 'Pods/ThreeDStudio/Shared/EmptyStateIllustration/EmptyStateIllustration'

import usePickerUpload from '../../Hooks/usePickerUpload'

// Marketplace listing, opened in a new tab so the AI session behind the modal survives.
// A bare /3d-models routes to the category hub (fast_categories#index); any query param
// sends it to the browsable listing (listing_page#index) instead, same as "Browse all".
const MARKETPLACE_HREF = '/3d-models?page=1'
const MARKETPLACE_LINK_ATTRIBUTES = { target: '_blank', rel: 'noopener noreferrer' }

const uploadIcon = <Icon svgComponent={Upload2} size={iconSize} color="light" notSpaced />
const searchIcon = <Icon svgComponent={Search} size={iconSize} color="dark" notSpaced />

function EmptyState({ onUploadStart }) {
  const t = useTranslation()
  const { accept, inputRef, isLoading, onFileChange, onFileClick } = usePickerUpload(onUploadStart)

  return (
    <div className="three-d-model-picker__empty">
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        onChange={!isLoading ? onFileChange : undefined}
        aria-hidden
        tabIndex={-1}
        disabled={isLoading}
        style={{ display: 'none' }}
      />
      <div className="three-d-model-picker__empty-content">
        <EmptyStateIllustration />
        <div className="three-d-model-picker__empty-text">
          <p className="three-d-model-picker__empty-title cgt-heading-300">
            {t('threeDModelPicker.empty.title')}
          </p>
          <p className="three-d-model-picker__empty-description cgt-body-md">
            {t('threeDModelPicker.empty.description')}
          </p>
        </div>
      </div>
      <div className="three-d-model-picker__empty-actions">
        <Button
          type="primary"
          variant="with-icon"
          size="small"
          actionType="button"
          icon={uploadIcon}
          disabled={isLoading}
          onClick={!isLoading ? onFileClick : undefined}
        >
          {t('threeDModelPicker.uploadTile')}
        </Button>
        <Button
          type="secondary"
          variant="with-icon"
          size="small"
          icon={searchIcon}
          href={MARKETPLACE_HREF}
          linkAttributes={MARKETPLACE_LINK_ATTRIBUTES}
        >
          {t('threeDModelPicker.empty.searchMarketplace')}
        </Button>
      </div>
    </div>
  )
}

EmptyState.propTypes = {
  onUploadStart: func.isRequired,
}

export default memo(EmptyState)
